import { getCookie } from 'cookies-next';

export function getUserIdentifiersClientSafe() {
  const sessionRaw = getCookie('session.userInfo');
  const fallbackTrackingId = getCookie('userTrackingId');

  let hkSha256Email = 'NULL';
  let hkUserTrackingId = '';
  let hkExternalUserId: string | null = null;

  if (sessionRaw && typeof sessionRaw === 'string') {
    try {
      const parsed = JSON.parse(sessionRaw);
      hkSha256Email = parsed._hke || 'NULL';
      hkUserTrackingId = parsed.userTrackingId || '';
      hkExternalUserId = parsed._hkeui || null;
    } catch (err) {
      console.error('Cookie parse error:', err);
    }
  } else if (fallbackTrackingId && typeof fallbackTrackingId === 'string') {
    hkUserTrackingId = fallbackTrackingId;
  }

  return {
    hkSha256Email,
    hkUserTrackingId,
    hkExternalUserId,
  };
}
